import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/*<div className="footer-content">*/}
        {/*<div className="footer-section">*/}
          {/*<h3>关于我们</h3>*/}
          {/*<p>俄星计划是面向俄罗斯市场的KOL建联平台，致力于为品牌方和本地红人提供高效、透明的合作机会。</p>*/}
        {/*</div>*/}
        {/*<div className="footer-section">*/}
          {/*<h3>联系方式</h3>*/}
          {/*<p>邮箱：contact@russiakol.com</p>*/}
          {/*<p>电话：+86 123 4567 8900</p>*/}
        {/*</div>*/}
        {/*<div className="footer-section">*/}
          {/*<h3>关注我们</h3>*/}
          {/*<div className="social-links">*/}
            {/*<a href="#" className="social-link">微信</a>*/}
            {/*<a href="#" className="social-link">微博</a>*/}
            {/*<a href="#" className="social-link">LinkedIn</a>*/}
          {/*</div>*/}
        {/*</div>*/}
      {/*</div>*/}
      <div className="footer-bottom">
        <div className="footer-links">
          <a href="#">隐私政策</a>
          <a href="#">服务条款</a>
          <a href="#">帮助中心</a>
        </div>
        <div className="copyright">
          <p>© 2025 东方星城网络 版权所有</p>
          <p>
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
               粤ICP备2025423702号-1
            </a>
            {/*<span className="divider">|</span>*/}
            {/*<a href="http://www.beian.gov.cn/" target="_blank" rel="noopener noreferrer">*/}
              {/*<img src="/police-badge.svg" alt="公安备案图标" className="police-badge" />*/}
              {/*粤公网安备 XXXXXXXXXXXX号*/}
            {/*</a>*/}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 